module.exports = __webpack_public_path__ + "img/Flag_of_Cape_Verde.66a51943.svg";